let BarChart = mc.charts.BarChart;

let MetricUtil = require("../util/MetricUtil");

let MetricBrief = function (props) {
  let { data, category } = props;
  let domain = [0, (mc.math.MILLIS_PER_HOUR / 1000) * 16];
  let total = mc.math.sum(data) * 1000;

  let categories = {
    "SLEEPING": ["SLEEPING:ASLEEP"],
    "RESTING": ["RESTING:LYING", "RESTING:SITTING", "RESTING:STANDING"],
    "MOVING": ["MOVING:WALKING", "MOVING:OTHER"]
  };

  let colors = categories[category].map((key) => MetricUtil.COLORS[key][0]);

  let tip = function (val, i) {
    return tx(categories[category][i]) + " (" + mc.format.duration(data[i] * 1000) + ")";
  };

  if (data.includes(undefined)) {
    data = [0];
  }

  return (
    <div className="rc-metric-brief">
      <BarChart
        width={250}
        height={20}
        domain={domain}
        data={data}
        colors={colors}
        tip={tip}
        transition={0}/>
      <div className="rc-metric-brief-duration">
        {isNaN(total) ? "N/A" : mc.format.duration(total)}
      </div>
    </div>
  );
};

module.exports = MetricBrief;
